import React, { useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";

import "../styles/AboutUs.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Link } from "react-router-dom";
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
const census = "/img/census.png";

const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";
const AboutUsImage = "/img/aboutus1.avif";
const sourcelogo1 = "/img/unemployment-logo.png";
const sourcelogo2 = "/img/utah-job-logo.png";
const kem = "/img/kem.png";

export default function CopyRight() {
  const [modalShow, setModalShow] = React.useState(false);
  const iconData = [
    { icon: "fa-fighter-jet", title: "Aerospace and Defense" },
    { icon: "fa-seedling", title: "Agriculture, Food, and Natural Resources" },
    { icon: "fa-briefcase", title: "Business, Finance, and Marketing" },
    { icon: "fa-cogs", title: "Engineering and Technology" },
    { icon: "fa-hands-helping", title: "Human Services" },
    { icon: "fa-truck", title: "Transportation, Distribution, and Logistics" },
    { icon: "fa-building", title: "Architecture and Construction" },
    { icon: "fa-laptop-code", title: "Computer Science and IT" },
    { icon: "fa-heartbeat", title: "Health Science" },
    {
      icon: "fa-balance-scale",
      title: "Law, Public Safety, Corrections, and Security",
    },
    {
      icon: "fa-paint-brush",
      title: "Arts, Audio/Visual Technology, and Communication",
    },
    { icon: "fa-graduation-cap", title: "Education and Training" },
    { icon: "fa-concierge-bell", title: "Hospitality and Tourism" },
    { icon: "fa-industry", title: "Manufacturing" },
  ];

  const navbarRef = useRef(null);

  // Close the navbar on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        const navbarCollapse =
          navbarRef.current.querySelector(".navbar-collapse");
        if (navbarCollapse) {
          navbarCollapse.classList.remove("show"); // Close the navbar
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <LandingSection
        data={{ imageName: "copyright.webp", title: "Copyright Disclaimer" }}
      />

      <div className="mt-[3rem] px-4 sm:px-0 about-us-content">
        <h2
          style={{
            fontSize: "40px",
            textAlign: "center",
            marginTop: "60px",
            color: "#0b3378",
          }}
        >
          Copyright Disclaimer
        </h2>
        <p
          style={{
            fontSize: "24px",
            marginTop: "30px",
            marginBottom: "60px",
            color: "#0b3378",
          }}
          className="text-center"
        >
          Copyright Disclaimer for Images on UTahData.org
        </p>

        <ul className="about-us-list">
          <li>
            UTahData.org respects the intellectual property rights of others.
            All images used on this website may be subject to their own
            copyrights, owned by third parties. We do not claim ownership of any
            copyrighted images unless explicitly stated.
          </li>
          <li>
            Our use of images is intended for informational and educational
            purposes, and no copyright infringement is intended. If you believe
            that any image on this site violates your copyright, please contact
            us at bodex@bodex.io so we can promptly review and address your
            concerns.
          </li>          
        </ul>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}
